const appConfig = {
  // backend url (with slash at end)
  URL: 'https://multihome.hu/',
  CONTACTEMAIL: 'info@multihome.hu',
  DEFAULTLANG: 'hu',
};

export default appConfig;
